import { useState, useEffect } from 'react';

import { breakpoints } from '@styles/mediaQuery';

const useDevice = () => {
  const isClient = typeof window !== 'undefined';
  const preBuildBreakpoints = {
    mobileL: breakpoints.mobileL,
    laptopS: breakpoints.laptopS,
    laptopL: breakpoints.laptopL,
    desktopM: breakpoints.desktopM,
  };

  const { laptopS, mobileL, laptopL, desktopM } = preBuildBreakpoints;

  const calcIsMobile = () => isClient && window.innerWidth <= mobileL;
  const calcIsTablet = () =>
    isClient && mobileL < window.innerWidth && window.innerWidth < laptopS;
  const calcIsLaptop = () =>
    isClient && laptopS <= window.innerWidth && window.innerWidth <= laptopL;
  const calcIsDesktop = () => isClient && desktopM <= window.innerWidth;

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isLaptop, setIsLaptop] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(calcIsMobile());
      setIsTablet(calcIsTablet());
      setIsLaptop(calcIsLaptop());
      setIsDesktop(calcIsDesktop());
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, isTablet, isLaptop, isDesktop };
};

export default useDevice;
